import axios from "axios";
import authHeader from "./services/auth-header";

export default axios.create({
  // where the backend is running+/api
  //baseURL: "http://localhost:8080/api",
  baseURL: "https://be-dev.quickquotescabinets.com/api",
  headers: authHeader()
});